/**
 * Rotas do Account (`VITE_ACCOUNT_URL`), dono do login e da assinatura do usuário.
 *
 * Toda ida a uma dessas rotas leva no `redirect` a URL para onde o Account deve devolver o usuário. O
 * Account aceita qualquer URL ali (não há lista de domínios permitidos), então nenhum ambiente do
 * planning-app precisa ser liberado do lado dele. A tela inicial (`buildAccountHomeUrl`) é a exceção: vai
 * sem `redirect`.
 */
export const ACCOUNT_ROUTES = {
  /** Login. Também é o destino do logout, que volta para a raiz do planning-app. */
  login: '/login',
  /** Assinatura, para quem não tem a capability `product:planningapp`. */
  subscription: '/subscription',
  /** Gerenciar assinatura, aberto em nova aba pelo link da seção Assinatura das Configurações. */
  manageSubscription: '/manage-subscription'
} as const

export type AccountRoute = (typeof ACCOUNT_ROUTES)[keyof typeof ACCOUNT_ROUTES]

/**
 * Monta `<ACCOUNT><rota>?redirect=<url_original>`. A URL de origem vai inteira por `encodeURIComponent`:
 * sem isso, a query string e o hash dela virariam parâmetros e hash da própria URL do Account.
 */
export function buildAccountUrl(route: AccountRoute, redirectUrl: string): string {
  return `${import.meta.env.VITE_ACCOUNT_URL}${route}?redirect=${encodeURIComponent(redirectUrl)}`
}

/** Tela inicial do Account, sem `redirect`: aberta em nova aba pelo link "Gerenciar conta" das Configurações. */
export function buildAccountHomeUrl(): string {
  return `${import.meta.env.VITE_ACCOUNT_URL}/`
}

/** Leva o usuário à rota do Account, com a URL em que ele está agora no `redirect`. */
export function redirectToAccount(route: AccountRoute): void {
  window.location.href = buildAccountUrl(route, window.location.href)
}
